import {
  AdministrationRole,
  GuaranteesFileType,
} from '~/store/guarantees/types.ts';
import type { TInternalApprovalLetterConfig, TInternalApprovalType } from './types.ts';

export const UDBTF_APPROVAL_LETTER_TEXT = {
  sectionStep: 'УДБТФ',
  sectionTitle: 'Лист-погодження',
  sectionDescription: 'Перегляньте сформований лист-погодження перед підписанням.',
  openButton: 'Відкрити PDF в новій вкладці',
  previewTitle: 'Лист-погодження',
  revokeButton: 'Відкликати',
  signAndConfirmButton: 'Підписати та підтвердити',
  signingSuccessMessage: 'Лист-погодження успішно підписано та підтверджено',
  revokeSuccessMessage: 'Заявку успішно відкликано',
  successCloseButton: 'Закрити',
} as const;

export const UDBTF_APPROVAL_LETTER_REVOKE_MODAL_TEXT = {
  title: 'Відкликати заявку',
  description: 'Введіть коментар до відкликання заявки.',
  label: 'Коментар',
  cancelButton: 'Скасувати',
  confirmButton: 'Підтвердити',
} as const;

export const UDBTF_APPROVAL_LETTER_ACCESS_DENIED_TEXT =
  'У вас немає прав доступу до опрацювання заявки УДБТФ.';

export const UDBTF_APPROVAL_LETTER_LOADING_TEXT = 'Завантажуємо документ...';
export const UDBTF_APPROVAL_LETTER_MISSING_PDF_TEXT =
  'Не вдалося завантажити PDF документ';
export const UDBTF_APPROVAL_LETTER_MISSING_SIGN_FILE_TEXT =
  'Не вдалося знайти файл листа-погодження для підпису';
export const UDBTF_APPROVAL_LETTER_QR_TIMEOUT_TEXT = 'Час підписання QR-коду вичерпано';
export const UDBTF_APPROVAL_LETTER_MISSING_VERSION_TEXT =
  'Не вдалося визначити версію заявки для оновлення статусу';

export const UDBTF_APPROVAL_LETTER_GET_STARTED_PATH =
  '/guarantees/administrator/get-started';
export const UDBTF_APPROVAL_LETTER_TASKS_PATH = '/tasks';

export const INTERNAL_APPROVAL_ADDITIONAL_DESCRIPTION_TEXT = {
  label: 'Додатковий опис',
  placeholder: 'Введіть додатковий опис',
  confirmButton: 'Підтвердити',
  maxLength: 500,
} as const;

export const INTERNAL_APPROVAL_CONCLUSION_DOCUMENT_TEXT = {
  uoTitle: 'Додаток №1 до листа-погодження',
  umvnTitle: 'Додаток №2 до листа-погодження',
} as const;

export const INTERNAL_APPROVAL_LOCAL_SUCCESS_TEXT = {
  approved: 'Лист-погодження успішно підписано',
  denied: 'Коментар до відкликання збережено',
} as const;

const UO_APPROVAL_LETTER_TEXT = {
  ...UDBTF_APPROVAL_LETTER_TEXT,
  sectionStep: 'ЮО',
  previewTitle: 'Лист-погодження ЮО',
} as const;

const UMVN_APPROVAL_LETTER_TEXT = {
  ...UDBTF_APPROVAL_LETTER_TEXT,
  sectionStep: 'УМВН',
  previewTitle: 'Лист-погодження УМВН',
} as const;

export const INTERNAL_APPROVAL_LETTER_CONFIG = {
  udbtf: {
    accessDeniedText: UDBTF_APPROVAL_LETTER_ACCESS_DENIED_TEXT,
    fileType: GuaranteesFileType.LETTER_OF_APPROVAL_UDBTF,
    hasAdditionalDescription: false,
    pageKey: 'udbtf',
    role: AdministrationRole.UBTF_ADMINISTRATOR,
    texts: UDBTF_APPROVAL_LETTER_TEXT,
  },
  uo: {
    accessDeniedText: 'У вас немає прав доступу до опрацювання заявки ЮО.',
    conclusionDocument: {
      fileType: GuaranteesFileType.ATTACHMENT_LETTER_OF_APPROVAL_UO,
      previewTitle: INTERNAL_APPROVAL_CONCLUSION_DOCUMENT_TEXT.uoTitle,
      sectionDescription: '',
      sectionStep: 'Додаток',
      sectionTitle: INTERNAL_APPROVAL_CONCLUSION_DOCUMENT_TEXT.uoTitle,
    },
    fileType: GuaranteesFileType.LETTER_OF_APPROVAL_UO,
    hasAdditionalDescription: true,
    pageKey: 'uo',
    role: AdministrationRole.UO_ADMINISTRATOR,
    texts: UO_APPROVAL_LETTER_TEXT,
  },
  umvn: {
    accessDeniedText: 'У вас немає прав доступу до опрацювання заявки УМВН.',
    conclusionDocument: {
      fileType: GuaranteesFileType.ATTACHMENT_LETTER_OF_APPROVAL_UMVN,
      previewTitle: INTERNAL_APPROVAL_CONCLUSION_DOCUMENT_TEXT.umvnTitle,
      sectionDescription: '',
      sectionStep: 'Додаток',
      sectionTitle: INTERNAL_APPROVAL_CONCLUSION_DOCUMENT_TEXT.umvnTitle,
    },
    fileType: GuaranteesFileType.LETTER_OF_APPROVAL_UMVN,
    hasAdditionalDescription: true,
    pageKey: 'umvn',
    role: AdministrationRole.UMVN_ADMINISTRATOR,
    texts: UMVN_APPROVAL_LETTER_TEXT,
  },
} as const satisfies Record<TInternalApprovalType, TInternalApprovalLetterConfig>;
